module.exports = __webpack_public_path__ + "static/media/box-icon.bce33133.svg";